export class Config {

    public static baseURL: string = "https://unknown.cz/lucka/rest";

    public static theme = {
        typography: {
          useNextVariants: true,
        },
        palette: {
          primary: {
            main: "#e040fb"
          }
        }
      };

}


// WEBPACK FOOTER //
// ./src/Config.tsx